import styled from "styled-components";

import {COLOR} from "config/color";

export const ModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${COLOR.fontColorSecondary};
  width: 65%;
  padding: 20px 40px 40px 40px;
  &:focus {
    outline: none;
  }
  .header {
    display: flex;
    position: relative;
    top: -5px;
    right: -25px;
    svg {
      color: ${COLOR.fontColorPrimary};
      margin-left: auto;
      font-size: 1.5rem;
    }
  }

  .content {
    display: grid;
    height: 100%;
    .content_item {
      margin: 5px 0;
      line-height: 2;
      font-size: 1rem;
      text-align: start;
      font-weight: 300;
      span {
        font-size: 0.93rem;
        color: gray;
      }
    }

    .close_btn {
      width: 80%;
      margin: 20px auto;
      padding: 0.8rem 2.2rem;
      font-size: 1.2rem;
    }
  }
`;
